//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"Distance",0,"Expression",0],[0,"ManipulatorOffsetOrigin",1,0],[0,"ManipulatorRotationMatrix",1,0],[1,"ObjectsToReposition",0,"SelectNXObjectList",0],[1,"PartFaces",0,"SelectNXObjectList",0],[1,"PlanarObject",0,"SelectNXObjectList",0],[0,"PositionMethod",1,0],[0,"RotationAxisType",1,0],[0,"TranslatePartsOption",1,0],[0,"TranslateToOption",1,0]],[],[]];
SPLM.Mfg.AM.RepositionPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.RepositionPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.RepositionPartBuilder.Method = Object.freeze({
    "Rotate" : "Rotate", "Translate" : "Translate", "Align" : "Align"});

SPLM.Mfg.AM.RepositionPartBuilder.RotateAxisType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "NegativeX" : "NegativeX", "NegativeY" : "NegativeY", "NegativeZ" : "NegativeZ", "Dynamic" : "Dynamic", "Viewdirection" : "Viewdirection"});

SPLM.Mfg.AM.RepositionPartBuilder.TranslateToType = Object.freeze({
    "BuildPlate" : "BuildPlate", "BuildTrayCenter" : "BuildTrayCenter", "FaceOrPlane" : "FaceOrPlane"});

SPLM.Mfg.AM.RepositionPartBuilder.TranslatePartsType = Object.freeze({
    "OneByOne" : "OneByOne", "AsAGroup" : "AsAGroup"});

export default SPLM;